import React from 'react';
import { useHistory } from 'react-router';
import { Fade } from '@material-ui/core';
import Routes from 'routes';
import { grey } from 'globals/colors';
import { FsDirection } from 'globals/types';
import defaultLocales from 'globals/locales/default';
import { ReactComponent as LogoSignet } from 'assets/icons/brand/fs-signet.svg';
import FsVectorArrowSmallIcon from 'ui-elements/icons/FsVectorArrowSmall';
import FsAvatarNavMenu from 'ui-elements/common-elements/FsAvatarNavMenu';
import {
  BackToPanelLabel,
  BackToPanelLink,
  ContextBox,
  HeaderBox,
  LogInButton,
  LogInLabel,
  LogInWrapperBox,
  LogoWrapperBox,
  PageWrapperBox,
  RightTopBox,
  StyledIconButton,
} from './FsCenterBoxLayout.style-elements';

interface FsRegistrationProcessLayoutProps {
  withLogo?: boolean;
  withLogin?: boolean;
  isWhiteBackground?: boolean;
  withBackToPanel?: boolean;
  withAvatarMenu?: boolean;
  withContentCentering?: boolean;
}

const FsCenterBoxLayout: React.FC<FsRegistrationProcessLayoutProps> = ({
  children,
  withContentCentering = true,
  withLogo = true,
  withLogin = true,
  isWhiteBackground = true,
  withBackToPanel = false,
  withAvatarMenu = false,
}) => {
  const history = useHistory();

  const handleClick = (): void => {
    history.push(Routes.ROOT);
  };

  return (
    <Fade in timeout={1000}>
      <PageWrapperBox isWhiteBackground={isWhiteBackground}>
        <HeaderBox isStatic={!withContentCentering}>
          <LogoWrapperBox>
            {withLogo && (
              <StyledIconButton onClick={handleClick}>
                <LogoSignet />
              </StyledIconButton>
            )}
            {withBackToPanel && (
              <BackToPanelLink to={Routes.ROOT}>
                <FsVectorArrowSmallIcon
                  color={grey.V3}
                  direction={FsDirection.LEFT}
                />
                <BackToPanelLabel>
                  {defaultLocales.backToDashboard}
                </BackToPanelLabel>
              </BackToPanelLink>
            )}
          </LogoWrapperBox>
          <RightTopBox>
            {withLogin && (
              <LogInWrapperBox>
                <LogInLabel>{defaultLocales.haveAccountQuestion}</LogInLabel>
                <LogInButton onClick={handleClick}>
                  {defaultLocales.logIn}
                </LogInButton>
              </LogInWrapperBox>
            )}
            {withAvatarMenu && <FsAvatarNavMenu />}
          </RightTopBox>
        </HeaderBox>
        <ContextBox isFullHeight={withContentCentering}>{children}</ContextBox>
      </PageWrapperBox>
    </Fade>
  );
};

export default FsCenterBoxLayout;
